import React from 'react';

/**
 * PageContainer — ページ外郭コンテナ
 * ------------------------------------------------------------------
 * ページ全体を囲む共通の外郭。デザインシステムのコンテナトークン
 * （--container-max-width 1240px / --container-padding-x 36px）を適用する。
 *
 * 既存ページの `<div style={{ width: '90%', margin: '0 auto' }}>` パターンの置換先。
 * Ph.4 のレイアウト統合で全ページへ順次適用していく前提の最小実装。
 *
 * 設計方針（Ph.3）:
 *   - antd を必要としない素の div ラッパー（レイアウトのみの責務）。
 *   - 色・余白は tokens.css の CSS 変数のみ使用（HEX ハードコード禁止）。
 *
 * @param {object}      props
 * @param {React.ReactNode} props.children            内側コンテンツ
 * @param {boolean}     [props.fluid=false]           true で max-width を解除し全幅にする
 * @param {string|number} [props.maxWidth]            max-width の上書き（既定: --container-max-width）
 * @param {React.CSSProperties} [props.style]         追加スタイル（マージされる）
 * @param {string}      [props.className]             追加クラス名
 *
 * @example
 * <PageContainer>
 *   <PageHeader title="ユーザー管理" />
 *   <Table ... />
 * </PageContainer>
 */
const PageContainer = ({
  children,
  fluid = false,
  maxWidth,
  style,
  className,
  ...rest
}) => {
  const mergedStyle = {
    // box-sizing: border-box が必須。
    // width:100% + 左右 padding(36px) を content-box（ブラウザ既定）で計算すると、
    // 要素の総幅が「100% + 72px」になり、内容と無関係に常に横スクロールが出る。
    // border-box にすると padding が width に含まれ、横はみ出しが解消する。
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: fluid ? 'none' : maxWidth || 'var(--container-max-width)',
    margin: '0 auto',
    padding: '0 var(--container-padding-x)',
    ...style,
  };

  return (
    <div className={className} style={mergedStyle} {...rest}>
      {children}
    </div>
  );
};

export default PageContainer;
